// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import cursorClick02Icon from "@/assets/icons/cursor-click-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CursorClick02IconProps = Omit<IconProps, "name">;

export function CursorClick02Icon(props: CursorClick02IconProps): React.ReactNode {
  return <Icon name={cursorClick02Icon} {...props} />;
}
